/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { User } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getUsers(filterValues = {} ): Observable<User[]> {
    const params = new HttpParams({fromObject: filterValues});
    return this.httpClient.get<User[]>(`${environment.backendServer}/api/users`, {
      headers: this.LD_JSON_HEADERS,
      params
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  getUser(id: string): Observable<User> {
    return this.httpClient.get<User>(`${environment.backendServer}/api/users/${this.extractId(id)}`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  createUser(user: User): Observable<User> {
    return this.httpClient.post<User>(`${environment.backendServer}/api/users`, user, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  updateUser(user: User): Observable<User> {
    return this.httpClient.put<User>(`${environment.backendServer}/api/users/${this.extractId(user['@id'])}`, user, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  deactivateUser(user: User): Observable<boolean> {
    return this.httpClient.post<{success: boolean}>(`${environment.backendServer}/api/users/deactivate`, {
      userId: this.extractId(user['@id']),
    }, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body.success)
    );
  }
}
